module.exports = "https://bin.bnbstatic.com/_next/static/images/info-5ce054cd9d6224c3589167676475b5d5.png";